import {
    Flex,
    Form,
    Modal
  } from "antd";
  import React from "react";
  import { useState } from "react";
  import { useTranslation } from "react-i18next";
  import { CustomTitle } from "../../../../../common/customTitle";
  
  const DescriptionDialog = ({ open, onClose, description }) => {
    /* i18n dependencies */
    const { t } = useTranslation();
    /* i18n dependencies */
  
    /* loading dependencies */
    const [loading, setLoading] = useState(false);
    /* loading dependencies */
  
  
    /* dialog close dependencies */
    const handleDialogClose = () => {
      onClose();
    };
    /* dialog close dependencies */

  
    return (
      <Modal
        open={open}
        onCancel={handleDialogClose}
        footer={false}
        confirmLoading={loading}
      >
        <Flex vertical gap="2rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
        {t("walletInfo.description")}
        </CustomTitle>
        {description || "-"}
        </Flex>
      </Modal>
    );
  };
  
  export default React.memo(DescriptionDialog);
  